import { createSlice } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { ConversationalBuilderState } from 'builder/features/conversationalBuilder/types'

const initialState: ConversationalBuilderState = {
  messages: [],
  loading: false,
  error: null,
  pendingChanges: [],
}

export const selectors = {
  messages: (state: Store) => state.conversationalBuilder.messages,
  loading: (state: Store) => state.conversationalBuilder.loading,
  error: (state: Store) => state.conversationalBuilder.error,
  pendingChanges: (state: Store) => state.conversationalBuilder.pendingChanges,
}

const { reducer, actions } = createSlice({
  name: 'conversationalBuilder',
  initialState,
  reducers: {
    // eslint-disable-next-line
    sendMessage: (state, _action) => {
      state.loading = true
      state.error = null
    },
    addUserMessage: (state, action) => {
      state.messages.push({ role: 'user', content: action.payload })
    },
    receiveMessage: (state, action) => {
      const { payload } = action
      state.messages.push({
        role: 'assistant',
        content: payload.assistantMessage,
        changes: payload.changes || [],
      })
      if (payload.changes && payload.changes.length > 0) {
        state.pendingChanges = payload.changes
      }
      state.loading = false
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    refreshLastMessage: state => {
      if (
        state.messages.length > 0 &&
        state.messages[state.messages.length - 1].role === 'assistant'
      ) {
        state.messages.pop()
      }
      state.loading = true
      state.error = null
    },
    applyPendingChanges: () => {},
    clearPendingChanges: state => {
      state.pendingChanges = []
    },
  },
})

export { reducer, actions }
